/**
 * Wrap Chinese (CJK) runs so they can use LXGW WenKai TC.
 * - Product thumbnail titles/vendors (not price)
 * - Main menu + mobile nav labels
 * - Page/section headings typography
 * - Product details page description / body copy
 * Also title-cases English in .section-header (e.g. Newest Selections).
 */
(function () {
  var CJK_RE =
    /[\u3000-\u303F\u3040-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFF00-\uFFEF]+/g;
  var SELECTOR = [
    ".thumbnail .info__text .title",
    ".thumbnail .info__text .vendor",
    "#nav #menu a",
    "#nav .submenu a",
    "#nav .mega-menu a",
    "#mobile_nav a",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    ".section-header",
    ".headline",
    ".collection_title",
    ".product_name",
    ".recommended-title",
    ".banner_title",
    ".banner-section__caption-headline",
    ".slideshow__caption-headline",
    ".faq-heading",
    // Product details description / meta body copy
    ".product_section .description",
    ".description--bottom .description",
    ".product-template-section .description",
  ].join(", ");

  function titleCaseEnglish(str) {
    return String(str).replace(/[A-Za-z][A-Za-z']*/g, function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function wrapTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || !CJK_RE.test(text)) return;
    CJK_RE.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var last = 0;
    var match;
    while ((match = CJK_RE.exec(text))) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      }
      var span = document.createElement("span");
      span.className = "cjk-text";
      span.textContent = match[0];
      frag.appendChild(span);
      last = match.index + match[0].length;
    }
    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function titleCaseEnglishNodes(el) {
    if (!el || !el.closest || !el.closest(".section-header")) return;
    var nodes = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest(".cjk-text")) continue;
      if (!/[A-Za-z]/.test(node.nodeValue || "")) continue;
      nodes.push(node);
    }
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].nodeValue = titleCaseEnglish(nodes[i].nodeValue);
    }
  }

  function walk(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.classList && el.classList.contains("cjk-text")) return;
    if (el.getAttribute && el.getAttribute("data-cjk-wrapped") === "1") return;

    var nodes = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest(".cjk-text")) continue;
      nodes.push(node);
    }
    for (var i = 0; i < nodes.length; i++) wrapTextNode(nodes[i]);
    titleCaseEnglishNodes(el);
    el.setAttribute("data-cjk-wrapped", "1");
  }

  function process(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) walk(els[i]);
  }

  function boot() {
    process(document);
    setTimeout(function () {
      process(document);
    }, 400);
    if (typeof MutationObserver === "undefined") return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SELECTOR)) walk(n);
          else if (n.querySelectorAll) process(n);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
